import { render, staticRenderFns } from "./AutomaticBackupsConfirmation.vue?vue&type=template&id=156f34d7&scoped=true"
import script from "./AutomaticBackupsConfirmation.vue?vue&type=script&lang=js"
export * from "./AutomaticBackupsConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f34d7",
  null
  
)

export default component.exports